ApplicationSerializer = require './application'

module.exports = App.ModifierSchemeSerializer = ApplicationSerializer.extend DS.EmbeddedRecordsMixin,
  attrs:
    restaurant_prices:
      deserialize: 'records'
      serialize: 'records'
    modifier_scheme_items:
      deserialize: 'records'
      serialize: 'records'
